"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionButton = exports.ActionsWrapper = exports.ContentWrapper = exports.StyledIconButton = exports.TitleTypography = exports.Header = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const button_1 = __importDefault(require("../button"));
const icon_button_1 = __importDefault(require("../icon-button"));
const typography_1 = __importDefault(require("../typography"));
const PREFIX = "Dialog";
exports.classes = {
    "bg-white": `${PREFIX}-bg-white`,
    "bg-pearl": `${PREFIX}-bg-pearl`,
    "bg-alabaster": `${PREFIX}-bg-alabaster`,
    "width-sm": `${PREFIX}-width-sm`,
    "width-md": `${PREFIX}-width-md`,
    "width-lg": `${PREFIX}-width-lg`,
    "width-xl": `${PREFIX}-width-xl`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)",
    borderRadius: "3px",
    outline: "none",
    width: "calc(100% - 32px)",
    maxHeight: "calc(100% - 20px)",
    display: "flex",
    flexFlow: "column nowrap",
    [theme.breakpoints.up("md")]: {
        width: "calc(100% - 48px)"
    },
    [`&.${exports.classes["bg-white"]}`]: {
        backgroundColor: theme.colours.white
    },
    [`&.${exports.classes["bg-pearl"]}`]: {
        backgroundColor: theme.colours.pearl
    },
    [`&.${exports.classes["bg-alabaster"]}`]: {
        backgroundColor: theme.colours.alabaster
    },
    [`&.${exports.classes["width-sm"]}`]: {
        maxWidth: theme.breakpoints.values.sm
    },
    [`&.${exports.classes["width-md"]}`]: {
        maxWidth: theme.breakpoints.values.md
    },
    [`&.${exports.classes["width-lg"]}`]: {
        maxWidth: theme.breakpoints.values.lg
    },
    [`&.${exports.classes["width-xl"]}`]: {
        maxWidth: theme.breakpoints.values.xl
    }
}));
exports.Header = (0, styles_1.styled)("div")({
    display: "flex",
    flex: "0 0 auto",
    flexFlow: "row nowrap",
    justifyContent: "flex-end"
});
exports.TitleTypography = (0, styles_1.styled)(typography_1.default)({
    flex: "1 1 auto",
    margin: "30px 0 24px 30px",
    "&&:after": {
        marginBottom: 0
    }
});
exports.StyledIconButton = (0, styles_1.styled)(icon_button_1.default)(({ theme }) => ({
    color: theme.colours.charcoal,
    margin: "6px 6px 16px 16px"
}));
exports.ContentWrapper = (0, styles_1.styled)("div")({
    flex: "1 1 auto",
    overflowY: "scroll",
    marginBottom: "24px",
    padding: "0 30px"
});
exports.ActionsWrapper = (0, styles_1.styled)("div")({
    display: "flex",
    flex: "0 0 auto",
    flexFlow: "row nowrap",
    justifyContent: "flex-end",
    padding: "0 30px 30px 30px",
    margin: "-8px"
});
exports.ActionButton = (0, styles_1.styled)(button_1.default)({
    margin: "8px"
});
//# sourceMappingURL=data:application/json;base64,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